import { Link } from "react-router-dom";
import { FlycherLogo } from "./FlycherLogo";

const TOOL_LINKS = [
  { to: "/itinerary", label: "AI Itinerary Builder" },
  { to: "/visa", label: "Visa Wizard" },
  { to: "/budget", label: "Budget Calculator" },
  { to: "/forex", label: "Forex & Bargain Check" },
  { to: "/reality-check", label: "Trip Reality Check" },
  { to: "/phrasebook", label: "Survival Phrasebook" },
  { to: "/explore", label: "Compare Prices" },
  { to: "/activities", label: "Activities & Deals" },
  { to: "/creator", label: "Be a Travel Creator" },
];

const DESTINATION_LINKS = [
  { slug: "vietnam", name: "Vietnam" },
  { slug: "thailand", name: "Thailand" },
  { slug: "bali", name: "Bali" },
  { slug: "japan", name: "Japan" },
  { slug: "maldives", name: "Maldives" },
  { slug: "malaysia", name: "Malaysia" },
  { slug: "singapore", name: "Singapore" },
  { slug: "sri-lanka", name: "Sri Lanka" },
  { slug: "nepal", name: "Nepal" },
  { slug: "philippines", name: "Philippines" },
];

export const Footer = () => (
  <footer
    data-testid="footer"
    className="border-t border-slate-200 mt-16"
    style={{ background: "#FDF8EE" }}
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid grid-cols-2 sm:grid-cols-4 gap-8">
      <div className="col-span-2 sm:col-span-1">
        <FlycherLogo size={42} theme="dark" />
        <p className="text-sm text-slate-600 mt-4 max-w-xs leading-relaxed">
          Bright, cinematic AI travel planning — designed for the Indian
          explorer. Free tools, INR-priced, Indian-passport aware.
        </p>
        <a
          href="https://instagram.com/wanderfullyflying"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block mt-4 text-xs font-mono text-slate-500 hover:text-slate-900"
        >
          @wanderfullyflying →
        </a>
      </div>

      <nav aria-label="Tools">
        <div className="kicker mb-3">Free tools</div>
        <ul className="text-sm text-slate-600 space-y-2">
          {TOOL_LINKS.map((t) => (
            <li key={t.to}>
              <Link to={t.to} className="hover:text-slate-900 hover:underline">
                {t.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <nav aria-label="Destinations">
        <div className="kicker mb-3">Plan by country</div>
        <ul className="text-sm text-slate-600 space-y-2">
          {DESTINATION_LINKS.map((d) => (
            <li key={d.slug}>
              <Link to={`/itinerary/${d.slug}`} className="hover:text-slate-900 hover:underline">
                {d.name} itinerary
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <nav aria-label="By Indian-passport visa">
        <div className="kicker mb-3">Visa for Indians</div>
        <ul className="text-sm text-slate-600 space-y-2">
          {DESTINATION_LINKS.slice(0, 10).map((d) => (
            <li key={d.slug}>
              <Link
                to="/visa"
                className="hover:text-slate-900 hover:underline"
              >
                {d.name} visa
              </Link>
            </li>
          ))}
        </ul>
        <p className="mt-4 text-[11px] text-slate-500 leading-relaxed">
          All prices in INR ₹. Bookings happen on trusted partners (Google
          Flights, Booking.com, Agoda, Klook, GetYourGuide).
        </p>
      </nav>
    </div>
    <div className="border-t border-slate-200/80 py-4 text-center text-[11px] tracking-widest uppercase text-slate-500">
      © Flycher · {new Date().getFullYear()} · Made for travelers from India · Bon voyage
    </div>
  </footer>
);
